import { API } from "@project/shared"
export interface IReturnJobList {
  count?: number
  data?: any
}

interface ISearchJobQuery {
  page?: string
  size?: string
  keyword?: string
  job_type?: string[]
  company_id?: string
  industry_type_new?: string[]
  occupation_type_new?: string[]
  area?: string[]
  annual_income?: {
    from?: string
    to?: string
  }
  age?: {
    from?: string
    to?: string
  }
  education_history?: []
  topic?: {
    recruitment_features?: string[]
    workplace_features?: string[]
    work_features?: string[]
    company_features?: string[]
    characteristics?: string[]
    thoughtfulness?: string[]
    company_type?: string[]
    working_type?: string[]
  }
  sales_agent_recommendation?: boolean
  free_words?: {
    condition?: string
    keywords?: string
  }[]
  logic?: "and" | "or"
}

export const fetchJobs = async ({ queryKey }): Promise<IReturnJobList> => {
  const params = {} as ISearchJobQuery
  params.page = queryKey[1].page
  params.size = queryKey[1].size
  params.keyword = queryKey[1].keyword
  params.company_id = queryKey[1]?.company_id
  params.job_type = queryKey[1]?.job_type?.join() || ""
  params.industry_type_new = queryKey[1]?.industry_type_new?.join() || ""
  params.occupation_type_new = queryKey[1]?.occupation_type_new?.join() || ""
  params.area = queryKey[1].area?.join() || ""
  params.annual_income = queryKey[1].annual_income
  params.age = queryKey[1].age
  params.education_history = queryKey[1]?.education_history?.join() || ""
  params.topic = queryKey[1]?.topic
  params.sales_agent_recommendation = queryKey[1].sales_agent_recommendation
  params.free_words = queryKey[1].free_words
  params.logic = queryKey[1].logic

  return API.get(`/jobs`, { params })
}

export const getJob = async (id) => {
  return API.get(`/jobs/${id}`)
}

export const getAllJob = async (id) => {
  return API.get(`/all-jobs/${id}`)
}

export const addJob = async (values): Promise<any> => {
  values.reward_amount = Number(values.reward_amount)
  return API.post(`/jobs`, values)
}

export const updateJob = async (values) => {
  const id = values.id
  values.reward_amount = Number(values.reward_amount)
  return API.put(`/jobs/${id}`, values)
}

export const deleteJob = async (id) => {
  return API.delete(`/jobs/${id}`)
}
